var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewLinkAccount2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 17.5C5 10.5964 10.5964 5 17.5 5H42.5C49.4036 5 55 10.5964 55 17.5V42.5C55 49.4036 49.4036 55 42.5 55H17.5C10.5964 55 5 49.4036 5 42.5V17.5ZM17.5 10C13.3579 10 10 13.3579 10 17.5V42.5C10 46.6421 13.3579 50 17.5 50H42.5C46.6421 50 50 46.6421 50 42.5V17.5C50 13.3579 46.6421 10 42.5 10H17.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 25C21.3807 25 22.5 26.1193 22.5 27.5L22.5 40C22.5 41.3807 21.3807 42.5 20 42.5C18.6193 42.5 17.5 41.3807 17.5 40L17.5 27.5C17.5 26.1193 18.6193 25 20 25Z",
    fill: "#A798B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 30C41.3807 30 42.5 31.1193 42.5 32.5V40C42.5 41.3807 41.3807 42.5 40 42.5C38.6193 42.5 37.5 41.3807 37.5 40L37.5 32.5C37.5 31.1193 38.6193 30 40 30Z",
    fill: "#A798B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 17.5C31.3807 17.5 32.5 18.6193 32.5 20L32.5 40C32.5 41.3807 31.3807 42.5 30 42.5C28.6193 42.5 27.5 41.3807 27.5 40L27.5 20C27.5 18.6193 28.6193 17.5 30 17.5Z",
    fill: "#A798B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLinkAccount2);
export default __webpack_public_path__ + "static/media/new-link-account-2.a7da5b95d6c4f8cacc02dabe466a13e2.svg";
export { ForwardRef as ReactComponent };